import { IApplicationState } from '../../types/redux';

export const selectPageTitle = (state: IApplicationState) => {
  const name = state.buildersProjects.data.location?.namePrepositional;
  let title = 'Проекты домов от строительных компаний';

  if (name) {
    title += ` ${name}`;
  }

  return title;
};
